export default "__VITE_ASSET__Coipx$1k__"